export const VITE_PRELOAD_RELOAD_KEY = 'vite-preload-reloaded';
